
require('../home-header/home-header.html');

require('../wia-launcher/wia-launcher.html');

require('../home-tabs/home-tabs.html');

require('../home-testimonial/home-testimonial.html');

require('../home-footer/home-footer.html');

const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=home-page> <template> <style include=shared-style></style> <style>" + require("./home-page.css") + "</style> <slot></slot> </template> </dom-module>");

require('./home-page.js');



// WEBPACK FOOTER //
// ./home/en-US/js/home-page/home-page.html